import { useState } from 'react'
import { setPrimaryPaymentMethod } from '../services/integrations'
import { useAuth } from '../modules/auth'
import type { PaymentMethod } from './useGetPaymentMethods'

const useSetPrimaryPaymentMethod = (): {
    setPrimaryHandler: (pmId: string) => Promise<PaymentMethod | undefined>
    loadingId: string | null
    error: string | null
} => {
    const [loadingId, setLoadingId] = useState<string | null>(null)
    const [error, setError] = useState<string | null>(null)
    const { currentUser } = useAuth()
    const organizationId = currentUser?.organizationId
    const hasOrganization = currentUser?.hasOrganization

    const setPrimaryHandler = async (pmId: string) => {
        try {
            setLoadingId(pmId)
            setError(null)
            const orgId = hasOrganization ? organizationId : undefined
            const res = await setPrimaryPaymentMethod(pmId, orgId)
            return res?.data?.data as PaymentMethod
        } catch (err: any) {
            setError(err?.response?.data?.message ?? 'Could not set primary card.')
            return undefined
        } finally {
            setLoadingId(null)
        }
    }

    return { setPrimaryHandler, loadingId, error }
}

export default useSetPrimaryPaymentMethod
